import MobxReactForm from 'mobx-react-form';
import dvr from 'mobx-react-form/lib/validators/DVR';
import validatorjs from 'validatorjs';
import _get from 'lodash/get';
import AuthStore from '../../../../stores/AuthStore';
import ProfileStore from '../../../../stores/ProfileStore';
import NotificationStore from '../../../../stores/NotificationStore';
import { i18nextInstance } from '../../../../../i18n';
const interceptor = {
    key: 'default',
    call: ({ change }) => {
        if (change.newValue !== null && change.newValue !== undefined) {
            return change;
        }
        change.newValue = '';
        return change;
    }
};
export const fields = [
    {
        name: 'zip',
        label: 'CheckoutPage:contactInformation:fieldLabels.zip',
        rules: 'required|string',
        value: '',
        interceptors: [interceptor]
    },
    {
        name: 'city',
        label: 'CheckoutPage:contactInformation:fieldLabels.city',
        rules: 'required|string',
        value: '',
        interceptors: [interceptor]
    },
    {
        name: 'street',
        label: 'CheckoutPage:contactInformation:fieldLabels.street',
        rules: 'required|string',
        value: '',
        interceptors: [interceptor]
    },
    {
        name: 'number',
        label: 'CheckoutPage:contactInformation:fieldLabels.number',
        rules: 'required|string',
        value: '',
        interceptors: [interceptor]
    },
    {
        name: 'password',
        label: 'CheckoutPage:contactInformation:fieldLabels.password',
        type: 'password',
        rules: 'password',
        value: '',
        interceptors: [interceptor]
    }
];
const hooks = {
    onSuccess: (form) => {
        const { password, ...userAddress } = form.values();
        return ProfileStore.updateUserProfileAdditionalAddress({ userAddress })
            .then(() => ProfileStore.getProfileData())
            .then(() => {
            const { email } = ProfileStore.userProfile;
            if (ProfileStore.tempPassword) {
                return AuthStore.changePassword(ProfileStore.tempPassword, password)
                    .then(() => AuthStore.authenticate(email, password));
            }
        })
            .catch((reason) => {
            const { errors } = reason;
            if (Array.isArray(errors)) {
                errors.forEach((error) => {
                    if (error.status === '500') {
                        NotificationStore.addNotification({
                            message: i18nextInstance.t('modals:offerRequest.saveDataFailed'),
                            level: 'error'
                        });
                        return;
                    }
                    const pointer = _get(error, 'source.pointer', '').split('/');
                    const fieldName = pointer.length ? pointer[pointer.length - 1] : '';
                    const errorDetail = _get(error, 'detail', '');
                    if (form.has(fieldName)) {
                        NotificationStore.addNotification({
                            message: `Error in field "${fieldName}": ${errorDetail}`,
                            level: 'error'
                        });
                        const field = form.$(fieldName);
                        if (field.hasNestedFields) {
                            field.each((field) => {
                                field.invalidate();
                            });
                        }
                        else {
                            field.invalidate(errorDetail);
                        }
                    }
                });
            }
            throw reason;
        });
    }
};
const plugins = {
    dvr: dvr({
        package: validatorjs
    })
};
const options = {
    showErrorsOnReset: false,
    validateOnBlur: true,
    validateOnChange: true
};
export default new MobxReactForm({ fields }, { hooks, plugins, options });
